const appConstants = {
  // API_ROOT_URL: 'http://localhost/imsproapi/',
  // API_ROOT_URL: 'https://ilmcampus.in/inst/imsproapi/',
  // API_ROOT_URL: 'https://ilmcampus.in/instv2/imsproapi/',
  API_ROOT_URL: 'https://sentrymanage.in/instv2/imsproapi/',
  COLORS: {
    APP_BG_COLOR: '#136FF8',
    BUTTON_BG_COLOR: '#0657CE',
    BUTTON_COLOR: '#ffffff',
    TEXT_COLOR: '#ffffff',
    TEXT_COLOR_BLACK: '#000000',
    TABLE_COLOR: '#0657CE',
  },
  SCREEN_SHOT: {
    TITLE: 'IMS',
    TEXT: '',
  },
  // Fee Structure endpoints
  FEE_STRUCTURE: {
    CREATE: 'create_fee_structure',
    LIST: 'list_fee_structures',
    GET: 'get_fee_structure',
    GET_FULL: 'get_fee_structure_full',
    UPDATE: 'update_fee_structure',
    DELETE: 'delete_fee_structure',
  },
  // Fee Slab endpoints
  FEE_SLAB: {
    CREATE: 'create_fee_structure_slab',
    LIST: 'list_fee_structure_slabs',
    GET: 'get_fee_structure_slab',
    UPDATE: 'update_fee_structure_slab',
    DELETE: 'delete_fee_structure_slab',
  },
  // Installment endpoints
  INSTALLMENTS: {
    CREATE: 'create_slab_installment',
    LIST: 'list_slab_installments',
    GET: 'get_slab_installment',
    UPDATE: 'update_slab_installment',
    DELETE: 'delete_slab_installment',
  },
  // Public Application endpoints
  APPLICATION: {
    SUBMIT: 'submit_application',
    GET_COURSES: 'get_public_courses',
  },
  // Batch Fee Due endpoints
  BATCH_FEE_DUE: {
    GET_PENDING_INSTALLMENTS: 'get_batch_pending_installments',
    BULK_MAKE_DUE: 'bulk_make_installment_due',
    GET_FEE_DUE_REMINDERS: 'get_fee_due_reminders',
  },
};

export default appConstants;
